import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ContractSigningWidgets from '../../../widgets/ContractSigning/ContractSigningWidgets'
import { getContractSubmitForm } from '../../../redux/actions/contract'
import { startLoading, doneLoading } from '../../../utils/loading'
import AttachFilesContractWidget from '../../../widgets/attachfiles/AttachFilesContractWidget'
import SubmitContractWidget from '../../../widgets/submitContractWidget/SubmitContractWidget'

export default function CenterSubmitContract() {
  //ขั้นที่ 4 บันทึกผลการทำสัญญา
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getContractSubmitForm(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms?.contractorList && (
          <ContractSigningWidgets schema={schema.forms.contractorList} />
        )}

        {schema?.forms?.contractFile && (
          <>
            <AttachFilesContractWidget
              schema={schema.forms.contractFile}
              isContractFile={true}
              isShowButtonMakeContract={true}
            />
          </>
        )}

        {schema?.forms?.attachmentGrantee && (
          <>
            <AttachFilesContractWidget
              schema={schema.forms.attachmentGrantee}
              isContractCenter={false}
            />
          </>
        )}

        {schema?.forms?.submitContract && (
          <SubmitContractWidget schema={schema.forms.submitContract} />
        )}
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'บันทึกผลการทำสัญญา (mock)',
    subHeader: null,
    forms: {
      contractFile: {
        header: 'รายการไฟล์ประกอบการทำสัญญา',
        buttonText: null,
        attachFiles: {
          id: null,
          name: null,
          description: null,
          buttonText: null,
          value: [
            {
              contractFileType: null,
              uploadDate: '0001-01-01T00:00:00',
              isChecked: false,
              enableDelete: false,
              label: 'ข้อเสนอโครงการ',
              name: 'proposal',
              path: null,
              type: null,
              size: 0,
              id: 'A8D9BC91-EC83-4235-8E7E-C56835955A00',
            },
            {
              contractFileType: null,
              uploadDate: '0001-01-01T00:00:00',
              isChecked: false,
              enableDelete: false,
              label: 'สัญญา',
              name: 'contract',
              path: '',
              type: null,
              size: 0,
              id: 'A7EB7A59-32FC-4022-98EE-FAFFDA45E65C',
            },
          ],
        },
      },
      attachmentGrantee: {
        header: 'รายการไฟล์คุณสมบัติผู้รับทุน',
        buttonText: null,
        attachFiles: {
          id: null,
          name: null,
          description: null,
          buttonText: null,
          value: [
            {
              contractFileType: 'เอกสารคุณสมบัติอื่นๆ (ถ้ามี)',
              uploadDate: '2021-06-01T07:34:03.47',
              isChecked: true,
              enableDelete: false,
              label: '3656b7e45cfa12857178e1cce7013b2e (2).jfif',
              name: '3656b7e45cfa12857178e1cce7013b2e (2).jfif',
              path: 'contract/attachment/B7A0D415-89EC-40A8-AAB3-B11C9C6F5EA2.jfif',
              type: null,
              size: 0,
              id: '73FBF734-C1B1-4A7D-B7F9-B03FAF7575FA',
            },
            {
              contractFileType: 'เอกสารคุณสมบัติอื่นๆ (ถ้ามี)',
              uploadDate: '2021-06-01T07:34:12.71',
              isChecked: true,
              enableDelete: false,
              label: '8118.jpg',
              name: '8118.jpg',
              path: 'contract/attachment/DFBDCB4A-96C7-4005-B3FF-C4EE683816B2.jpg',
              type: null,
              size: 0,
              id: 'CBDADD55-205E-4866-B622-A921D288283E',
            },
            {
              contractFileType: 'เอกสารคุณสมบัติอื่นๆ (ถ้ามี)',
              uploadDate: '2021-06-01T07:38:25.437',
              isChecked: false,
              enableDelete: true,
              label: '21.05.2021_11.26.24_REC.png',
              name: '21.05.2021_11.26.24_REC.png',
              path: 'contract/attachment/4BEF146F-8624-4297-8411-9950FF526010.png',
              type: null,
              size: 0,
              id: 'EB90F8E6-F241-418D-A7BC-51265DFE6CB9',
            },
          ],
        },
      },
      contractorList: {
        panelText: 'รายการผู้มีอำนาจลงนาม',
        buttonText: null,
        contractorList: [
          {
            no: 1,
            name: 'นายแพทย์ ไพโรจน์ เสาน่วม',
            contractorType: 'ผู้มีอำนาจลงนาม',
            signedDate: null,
          },
          {
            no: 2,
            name: 'คุณ วัลลภ บุญประเสริฐ',
            contractorType: 'ผู้รับทุน',
            signedDate: null,
          },
        ],
      },
      submitContract: {
        header: 'บันทึกผลการทำสัญญา',
        warningMessage:
          'โปรดแน่ใจว่าได้ทำการตรวจสอบสัญญาและเอกสารที่เกี่ยวข้องเป็นที่เรียบร้อยแล้ว จึงทำการบันทึกผลการทำสัญญา',
        buttonText: 'ผ่านการทำสัญญา',
      },
    },
  },
}
